//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'scratch',
  props: {
    cjimg: {
      type: String
    },
    lottery: {
      type: Boolean
    },
    msg: {
      type: String,
      default: ''
    },
    radius: {
      type: Number,
      default: 3
    },
    // 是否是弹窗显示
    ispop: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      context: '',
      show: false
    }
  },
  created () { },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      let canvas = this.$refs.mask
      // let context = canvas.getContext('2d')
      let _this = this
      var img = new Image()
      img.src = this.cjimg
      img.onload = function () {
        let context = canvas.getContext('2d')
        context.drawImage(img, 0, 0, 270, 162)
        context.globalCompositeOperation = 'destination-out'
        _this.context = context
      }
      // 鼠标按下 增加mousemove的事件监听
      canvas.addEventListener('touchstart', this.drawArcMouseHandle)
      canvas.addEventListener('touchsend', event => {
        // 鼠标抬起之后，把mousemove的事件监听撤销掉
        this.removeEventListener('touchmove', this.mousemoveHandle)
      })
      // 监听 touchmove
      canvas.addEventListener('touchmove', this.drawArcTouchHandle)
      this.show = true
    },
    // 根据鼠标的move画圆
    drawArcMouseHandle (event) {
      event.preventDefault()
      event.target.addEventListener('touchmove', this.mousemoveHandle)
    },
    // 为了能够移除movesemove的事件需要单独处理一下
    mousemoveHandle (event) {
      event.preventDefault()
      this.drawArcByPoint(event.pageX, event.pageY)
    },
    // 根据触摸点画圆
    drawArcTouchHandle (event) {
      event.preventDefault()
      var touch = event.touches[0]
      this.ispop ? this.drawArcByPoint(touch.clientX, touch.clientY) : this.drawArcByPoint(touch.pageX, touch.pageY)
    },
    // 根据某个点在canvas上画圆
    // x 坐标和 y 坐标 两个坐标是触摸点的坐标而不是画圆的圆心
    // 圆心通过计算得出
    drawArcByPoint (x, y) {
      this.context.beginPath()
      this.context.arc(
        x - canvas.offsetLeft,
        y - canvas.offsetTop,
        15,
        0,
        Math.PI * 2
      )
      this.context.closePath()
      this.context.fillStyle = '#ffffff'
      this.context.fill()
      this.checkComplete()
    },
    // 判断是否完成刮奖 点数大于80%
    checkComplete () {
      var imgData = this.context.getImageData(0, 0, 300, 120)
      var pxData = imgData.data // 获取字节数据
      var len = pxData.length // 获取字节长度
      var count = 0 // 记录透明点的个数
      // 主要的思想是 一个像素由四个数据组成，每个数据分别是 rgba() 所以第四个数据 a 表示alpha透明度
      for (var i = 0; i < len; i += 4) {
        var alpha = pxData[i + 3] // 获取每个像素的透明度
        if (alpha < 10) {
          // 透明度小于10
          count++
        }
      }
      var percent = count / (len / 4) // 计算百分比
      // 如果百分比大于0.8 则表示成功
      if (percent > 0.3) {
        if (this.lottery) {
          this.$emit('getLottery')
        }
      }
      if (percent >= 0.65) {
        this.showResult()
      }
    },
    // 显示刮奖结果
    showResult () {
      this.context.clearRect(0, 0, 270, 162)
    },
    clear () {
      this.$forceUpdate()
    }
  }
}
